import React from 'react';
import { C } from '../constants';

/**
 * Términos y condiciones de Solar Hub — pública, FUERA del shell (solar-hub.co/terminos), sin sesión.
 *
 * Existe porque Verifik exige en cada proyecto una URL de términos y otra de privacidad, y la de
 * términos no existía: el proyecto «Solar Hub — técnicos» usaba la de privacidad en las dos
 * (medido el 7-oct-2026). Texto para revisión del abogado, igual que los de MediNetz.
 */
export const VERSION_TERMINOS = '2026-10-07';

export default function Terminos() {
  return (
    <div style={{ minHeight: '100vh', background: C.dark, color: C.text }}>
      <header style={{
        position: 'sticky', top: 0, zIndex: 10, height: 48, padding: '0 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        borderBottom: `1px solid ${C.border}`,
        background: `linear-gradient(180deg, ${C.nav} 0%, ${C.nav2} 100%)`,
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'baseline', gap: 1, textDecoration: 'none' }}>
          <span style={{ fontWeight: 900, fontSize: 18, color: C.heading }}>Solar</span>
          <span style={{ fontWeight: 900, fontSize: 18, color: C.yellow }}>Hub</span>
        </a>
        <a href="/" style={{ fontSize: 12, color: C.teal, fontWeight: 700, textDecoration: 'none' }}>Volver a Solar Hub</a>
      </header>

      <main style={{ maxWidth: 720, margin: '0 auto', padding: '28px 20px 64px', lineHeight: 1.6, fontSize: 14 }}>
        <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', color: C.teal, margin: 0 }}>
          Versión {VERSION_TERMINOS}
        </p>
        <h1 style={{ margin: '6px 0 8px', fontSize: 26, fontWeight: 900, color: C.heading, letterSpacing: '-0.4px' }}>
          Términos y condiciones de uso
        </h1>
        <p style={{ margin: '0 0 22px', fontSize: 13, color: C.muted }}>
          Solar Hub es una plataforma de <strong style={{ color: C.heading }}>ALEBAS INGENIERÍA S.A.S.</strong>{' '}
          (Consultoría e Ingeniería en Eficiencia Energética S.A.S.), NIT 901.992.450-5, con domicilio en la
          CR 36 24 A 44 Oficina 2, Villavicencio (Meta), Colombia. Contacto:{' '}
          <a href="mailto:info@solar-hub.co" style={{ color: C.teal }}>info@solar-hub.co</a> · +57 316 308 5286.
        </p>

        <H>1. Aceptación y contratación electrónica</H>
        <p>
          Al usar Solar Hub, crear una cuenta, enviar una cotización o pagar, usted acepta estos términos.
          Los mensajes de datos, los clics de aceptación y los registros de la plataforma tienen validez y
          fuerza probatoria conforme a la Ley 527 de 1999. Si no está de acuerdo, no use la plataforma.
        </p>

        <H>2. Qué ofrece Solar Hub</H>
        <ul style={ul}>
          <li><strong style={{ color: C.heading }}>Cotizador gratuito:</strong> una estimación indicativa del sistema solar, su costo y su ahorro. No es una oferta vinculante: el diseño y el precio definitivos dependen de la visita técnica.</li>
          <li><strong style={{ color: C.heading }}>Estudio fotovoltaico y visita técnica:</strong> servicios de ingeniería pagos, con alcance y precio informados antes de pagar.</li>
          <li><strong style={{ color: C.heading }}>Tienda:</strong> venta de equipos con ficha técnica y precio con IVA incluido cuando aplique.</li>
          <li><strong style={{ color: C.heading }}>Red de instaladores:</strong> técnicos e ingenieros independientes que usan la plataforma con licencia. No son empleados de ALEBAS y responden por su servicio en los términos de su propio acuerdo.</li>
        </ul>

        <H>3. Derechos del consumidor (Ley 1480 de 2011)</H>
        <ul style={ul}>
          <li><strong style={{ color: C.heading }}>Información:</strong> le informamos de forma clara las características, el precio total con impuestos y las condiciones de cada producto o servicio antes de que pague (arts. 23, 26 y 50).</li>
          <li><strong style={{ color: C.heading }}>Garantía legal:</strong> los equipos y la instalación tienen la garantía legal de calidad, idoneidad y seguridad; la de los equipos se rige además por el término del fabricante cuando sea mayor (arts. 7 a 11).</li>
          <li><strong style={{ color: C.heading }}>Retracto:</strong> en las compras a distancia puede retractarse dentro de los cinco (5) días hábiles siguientes a la entrega del bien o a la celebración del contrato de servicios, salvo las excepciones de ley — entre ellas los servicios cuya prestación ya comenzó con su acuerdo y los bienes hechos a la medida (art. 47). El dinero se devuelve dentro de los treinta (30) días calendario siguientes.</li>
          <li><strong style={{ color: C.heading }}>Reversión del pago:</strong> si pagó con un medio electrónico y fue objeto de fraude, una operación no solicitada, el producto no llegó o no corresponde a lo pedido, puede pedir la reversión dentro de los cinco (5) días hábiles siguientes a que lo supo (art. 51).</li>
        </ul>

        <H>4. Pagos y facturación</H>
        <p>
          Los pagos se procesan por <strong style={{ color: C.heading }}>Wompi</strong> (Bancolombia) y los
          medios que la plataforma muestre en cada compra. Solar Hub no recibe ni guarda los datos de su
          tarjeta: se tokenizan directamente con la pasarela. ALEBAS emite la factura electrónica ante la
          DIAN. Un precio no se considera aceptado hasta que la plataforma confirma el pago.
        </p>

        <H>5. Propiedad intelectual — todos los derechos reservados</H>
        <p>
          El software, el código, los diseños, las bases de datos, los modelos de cálculo, la documentación
          y las marcas <strong style={{ color: C.heading }}>Solar Hub, FluxAI y ALEBAS</strong> son de ALEBAS o
          de sus licenciantes (Ley 23 de 1982 y Decisión Andina 351 de 1993). Usar la plataforma no le
          transfiere ningún derecho sobre ellos. Los documentos que la plataforma genera para usted (su
          cotización, su estudio) son para su uso personal y el de su proyecto.
        </p>

        <H>6. Uso aceptable</H>
        <p>
          No está permitido: copiar, extraer o reutilizar masivamente el contenido o los datos; descompilar
          o hacer ingeniería inversa; acceder a cuentas o datos ajenos; saltarse los controles de acceso;
          ni usar la plataforma para fines ilícitos. Esas conductas pueden constituir delitos informáticos
          (Ley 1273 de 2009) y llevan a la suspensión inmediata del acceso.
        </p>

        <H>7. Alcance de las estimaciones</H>
        <p>
          La producción y el ahorro se calculan con datos de irradiancia, tarifas publicadas y la
          información que usted entrega. La producción real varía con el clima, el sombreado, el estado
          de la instalación y los cambios regulatorios y tarifarios. Una estimación no es una garantía de
          ahorro, salvo que un contrato firmado diga otra cosa.
        </p>

        <H>8. Datos personales</H>
        <p>
          El tratamiento de sus datos se rige por la{' '}
          <a href="/privacidad" style={{ color: C.teal }}>Política de tratamiento de datos personales</a>{' '}
          (Ley 1581 de 2012).
        </p>

        <H>9. Peticiones, quejas y reclamos</H>
        <p>
          Puede radicar una PQR en la{' '}
          <a href="https://alebas.co/?linea=solarhub#radicar" style={{ color: C.teal }}>ventanilla única de ALEBAS</a>{' '}
          o escribir a <a href="mailto:info@solar-hub.co" style={{ color: C.teal }}>info@solar-hub.co</a>.
          También puede acudir a la Superintendencia de Industria y Comercio.
        </p>

        <H>10. Cambios a estos términos</H>
        <p>
          Si cambian, publicamos la nueva versión en esta página con su fecha. Los cambios no afectan las
          compras ya pagadas, que se rigen por la versión vigente cuando se hicieron.
        </p>

        <H>11. Ley aplicable y jurisdicción</H>
        <p>
          Estos términos se rigen por las leyes de la República de Colombia. Las controversias se
          resolverán ante los jueces de Villavicencio (Meta), sin perjuicio del derecho del consumidor de
          acudir a la Superintendencia de Industria y Comercio o al juez que la ley le permita elegir.
        </p>
      </main>
    </div>
  );
}

function H({ children }) {
  return (
    <h2 style={{ margin: '22px 0 8px', fontSize: 15, fontWeight: 800, color: C.heading }}>{children}</h2>
  );
}
const ul = { margin: '0 0 12px', paddingLeft: 18, color: C.text };
